import React from 'react';
import classnames from 'classnames';
import si from 'si';
import storage from 'storage';
import Rules from './Rules';
import {TextField, SelectField} from './FormFields/formFields'

class ContactMe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: props.firstName,
      lastName: props.lastName,
      email: props.email,
      phone: props.phone,
      reason: props.reason,
      reasons: [],
      comments: props.comments,
      submitted: false,
      returnUrl: storage.get('returnUrl') ? storage.get('returnUrl') : '',
    };

    this.firstNameValidation = new Rules({ required: true, requiredMessage: props.resources['PWS.ContactForm.FirstNameRequiredMessage'] });
    this.lastNameValidation = new Rules({ required: true, requiredMessage: props.resources['PWS.ContactForm.LastNameRequiredMessage'] });
    this.emailValidation = new Rules({ required: true, requiredMessage: props.resources['PWS.ContactForm.EmailRequiredMessage'], email: true, emailMessage: props.resources['PWS.ContactForm.EmailRequiredMessage'] });
    this.phoneValidation = new Rules({ required: true, requiredMessage: props.resources['PWS.ContactForm.PhoneRequiredMessage'] });

    this.handleChange = this.handleChange.bind(this);
    this.submitButton = this.submitButton.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
    this.registerErrors = this.registerErrors.bind(this);
    this.displayError = this.displayError.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillMount() {
      if (storage.get('selectedReason')) {
          this.setState({
              reason: storage.get('selectedReason')
          });
      }
      si.getContactMe().then( reasons => {
        let keyValueReasons = reasons.map((reason, i) => {
            return {'reason': reason};
        });
        this.setState({
          reasons: keyValueReasons
        });
      }, () => {
        this.setState({
         reasons: [
             {value: window.jenkon.resources["PWS.ContactForm.SponsorReason"], displayValue: window.jenkon.resources["PWS.ContactForm.SponsorReason"]},
             {value: window.jenkon.resources["PWS.ContactForm.OrderReason"], displayValue: window.jenkon.resources["PWS.ContactForm.OrderReason"]}
         ]
        });
      });
  }

  displayError(error) {
    if (!error || error.length === 0) { return null; }
    return (
      <div className={classnames("field-validation", {shown: !!error})}>
        <div className="display">{error}</div>
      </div>
    );
  }

  submitButton(isActive) {
    return (
      <button type="button" id="consultant-contact-button" onClick={this.submit} className={classnames("basic-submit-button", { "disabled": !isActive })}>{this.props.resources["PWS.ContactForm.SubmitButtonText"]}</button>
    );
  }

  submit() {
    var submitData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      ContactMeReason: this.state.reason,
      //phone: this.state.phone,
      Comments: this.state.comments
    };

    if (!this.canSubmit(submitData)) {
      this.registerErrors();
      return false;
    }

  	si.sendContactForm(submitData).then(function(success) {
  		if (success) {
  			this.setState({
          submitted: true
        });
        if (this.state['returnUrl'] !== '') {
            window.location.href = this.state['returnUrl'];
        }
  		} else {
  			console.log('Error sending content form');
  		}
  	}.bind(this));

  }

  handleChange(name, value) {
    var diff = {};
    diff[name] = value;
    this.setState(diff);
  }

  updateComments(e) {
    this.setState({comments: e.target.value});
  }

  registerErrors() {
    this.setState({
      firstNameError: this.firstNameValidation.getErrors(this.state.firstName),
      lastNameError: this.lastNameValidation.getErrors(this.state.lastName),
      emailError: this.emailValidation.getErrors(this.state.email)
      //phoneError: this.phoneValidation.getErrors(this.state.phone)
    });
  }

  canSubmit(fields) {
    return (
      this.firstNameValidation.isValid(fields.firstName)
      && this.lastNameValidation.isValid(fields.lastName)
      && this.emailValidation.isValid(fields.email)
    );
  }

  render() {
    if (this.state.submitted) {
        return (
         <h3 className="confirm-text" dangerouslySetInnerHTML={{ __html:this.props.resources["PWS.ContactForm.ConfirmText"] }} />
      );
    }
    return (
      <div className="contact-me">
        <div className="contact-form-wrapper site-container clearfix">
          <div className="consultant-contact-form-area clearfix">
                    <h2 className="basic-title buffer-bottom" dangerouslySetInnerHTML={{ __html:this.props.resources["PWS.ContactForm.PageTitleText"]}}></h2>
            <form className="consultant-contact-form">
                <TextField
                    ref="firstName"
                    handleChange={this.handleChange}
                    name="firstName"
                    value={this.state.firstName}
                    label={this.props.resources["PWS.ContactForm.FirstNameLabel"]}
                    Rules={this.firstNameValidation}
                />
                <TextField
                    ref="lastName"
                    handleChange={this.handleChange}
                    name="lastName"
                    value={this.state.lastName}
                    label={this.props.resources["PWS.ContactForm.LastNameLabel"]}
                    Rules={this.lastNameValidation}
                />
                <TextField
                    ref="email"
                    handleChange={this.handleChange}
                    name="email"
                    value={this.state.email}
                    label={this.props.resources["PWS.ContactForm.EmailLabel"]}
                    Rules={this.emailValidation}
                />
                <SelectField
                    ref="reason"
                    handleChange={this.handleChange}
                    name="reason"
                    value={this.state.reason}
                    label={window.jenkon.resources["PWS.ContactForm.SelectATopic"]}
                    optionData={this.state.reasons}
                    keys={{valueKey: 'reason', nameKey: 'reason'}}
                />
              <div className="field-container contact-form-wide-container">
                <label htmlFor="comment" className="visuallyhidden">{this.props.resources['PWS.ContactForm.CommentsLabel']}</label>
                <textarea onChange={this.updateComments.bind(this)} value={this.state.comments} rows="4" name="comments" id="comments" placeholder={this.props.resources['PWS.ContactForm.CommentsLabel']} className="input-bordered contact-form-comments"></textarea>
              </div>
              <div className="field-container contact-form-wide-container">
                <div className="required-field-legend">{this.props.resources['PWS.ContactForm.ValidationInstructionText']}</div>
                {this.submitButton(this.canSubmit(this.state))}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactMe;



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ContactMe.js